import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ConclusionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Conclusion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              A spatial Decision Support System designed for the prudent
              governance of protected areas (PA) will enhance the transparency
              in natural resources management while meeting societal needs.
              Visualisation of landscape dynamics through synthesis and
              integration of information would enable understanding the current
              status and predict likely changes, which are essential for
              effective decision-making towards sustainable management of
              natural resources. Visualisation of spatiotemporal changes
              indicates the decline in evergreen forest cover from 38.75 (1973)
              to 31.43% (2016) in SWLS. Similarly, a loss of deciduous forests
              from 50.09 to 37.43 % in BWLS during 1973-2016 with an increase of
              monoculture plantations and agriculture activities. Modeling and
              predicting likely LU change through CA-Markov highlights that the
              SWLS would witness further erosion of evergreen cover from 31.43
              to 28.84% (2016-2026) with increases in the area horticulture from
              21.46 to 28.08% (2026). BWLS also will witness an increase in
              monoculture plantations followed by horticulture. Deciduous forest
              would disappear from 37.43 to 34.71% (2016-2026) with an increase
              of horticulture from 15 to 19% in BWLS. Advance visualisation of
              likely LU changes would help to evolve appropriate and prudent
              management strategies to conserve ecologically sensitive PAs to
              sustain biodiversity.
            </p>
            <p>
              <strong>Acknowledgements: </strong>This research was supported the
              grant from (i) This study was supported with the financial grant
              from the Karnataka State Audit Accountant office,
              [Pr.AG(E&amp;RSA), Karnataka, Bengaluru,
              http://www.agkar.cag.gov.in/] and ENVIS division, The Ministry of
              Environment, Forests and Climate Change, GoI. We are grateful to
              the official languages section at IISc for the assistance in
              language editing. We acknowledge the sustained infrastructure
              support from (i) NRDMS division, The Ministry of Science and
              Technology (DST), Government of India, (ii) Indian Institute of
              Science and (iii) ENVIS Division, the Ministry of Environment
              Forests and Climate Change, Government of India.
            </p>

            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ConclusionPage;
